import { render, staticRenderFns } from "./SalonWaiting.vue?vue&type=template&id=7acd5bdb"
import script from "./SalonWaiting.vue?vue&type=script&lang=js"
export * from "./SalonWaiting.vue?vue&type=script&lang=js"
import style0 from "./SalonWaiting.vue?vue&type=style&index=0&id=7acd5bdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports